var React = require('react');

function X3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"X3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":0},React.createElement("polygon",{"points":"44.41 26.6 25.65 0 0 0 27.23 41.72 44.41 26.6","fill":"#f47643"})),React.createElement("polygon",{"points":"81.71 80.93 53.95 38.54 79.67 0 54.94 0 1.52 80.03 26.26 80.03 41.44 57.29 56.97 80.93 81.71 80.93","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

X3.defaultProps = {"viewBox":"0 0 81.71 80.93"};

module.exports = X3;

X3.default = X3;
